module.exports = __webpack_public_path__ + "static/media/mitteavalik_teave.ef06c384.svg";